import {clearString, FullAlphabet} from "../helpers/stringHelpers";

const cachedSpider = {};

const Spider = {
    groups: function (missing) {
        let mergedMissing = missing.join('');
        if (cachedSpider[mergedMissing]) {
            return cachedSpider[mergedMissing]
        }
        let myAlphabet = FullAlphabet.filter((str) => {
            return str !== missing[0].toLowerCase().replace('ch', '*') &&
                str !== missing[1].toLowerCase().replace('ch', '*') &&
                str !== missing[2].toLowerCase().replace('ch', '*')
        })
        let groups = [
            [myAlphabet[0], myAlphabet[1], myAlphabet[2]].join(''),
            [myAlphabet[3], myAlphabet[4], myAlphabet[5]].join(''),
            [myAlphabet[6], myAlphabet[7], myAlphabet[8]].join(''),
            [myAlphabet[9], myAlphabet[10], myAlphabet[11]].join(''),
            [myAlphabet[12], myAlphabet[13], myAlphabet[14]].join(''),
            [myAlphabet[15], myAlphabet[16], myAlphabet[17]].join(''),
            [myAlphabet[18], myAlphabet[19], myAlphabet[20]].join(''),
            [myAlphabet[21], myAlphabet[22], myAlphabet[23]].join(''),
            [myAlphabet[0], myAlphabet[9], myAlphabet[21]].join(''),
            [myAlphabet[3], myAlphabet[10], myAlphabet[18]].join(''),
            [myAlphabet[6], myAlphabet[11], myAlphabet[15]].join(''),
            [myAlphabet[1], myAlphabet[4], myAlphabet[7]].join(''),
            [myAlphabet[16], myAlphabet[19], myAlphabet[22]].join(''),
            [myAlphabet[8], myAlphabet[12], myAlphabet[17]].join(''),
            [myAlphabet[5], myAlphabet[13], myAlphabet[20]].join(''),
            [myAlphabet[2], myAlphabet[14], myAlphabet[23]].join(''),
        ]
        cachedSpider[mergedMissing] = groups;
        return cachedSpider[mergedMissing];
    }


}
export const SEPARATOR = ';'
export const methods = {
    cypher: function (input, hasCh=false, missing = ['ch', 'q', 'w'], params, sep = SEPARATOR) {
        let cyphered = []
        let groups = Spider.groups(missing);
        let cleared = clearString(input, !missing.includes('ch'));
        cleared.split('').forEach((char) => {
            if(char===' '){
                cyphered.push('')
            }else if (char.match(/[.,?!]/) || char.length==0) {
                cyphered.push(' ');
            }else if(char==="\n"){
                cyphered.push("\n")
            } else if(!missing.includes(char)){
                let filteredGrps = groups.filter((chars) => chars.includes(char));
                cyphered.push(filteredGrps[Math.floor(Math.random() * filteredGrps.length)]
                    .replaceAll(char, '')
                    .replaceAll('*','ch'))
            }
        })

        return cyphered.join(sep)
            .replaceAll(sep+sep, ' ')
            .replaceAll(sep+'\n'+sep, '\n')
            .replaceAll('\n'+sep, '\n')
            .replaceAll('*','ch')
    },
    decypher: function (input, hasCh=false, missing = ['ch', 'q', 'w'], params, sep = SEPARATOR) {
        let deciphered = []
        let groups = Spider.groups(missing);
        let text = input.replace('ch','*')
        let sparatorSpliter = new RegExp("[; |/"+sep+"]");
        text.split(sparatorSpliter).forEach((char) => {//.replace(' ','') bd;chi;jk;rs;kt mo;kt;bd;tv;is
            if (char.match(/[.,?! ]/) || char.length==0) {
                deciphered.push(' ');
            } else {
                let filteredGrps = groups.filter((chars) => {
                    if (missing.includes('ch')) {
                        return chars.includes(char[0]) && chars.includes(char[1])
                    } else {
                        return chars.includes(char.replace('ch', '*')[0]) && chars.includes(char.replace('ch', '*')[1])
                    }
                });
                if (missing.includes('ch')) {
                    deciphered.push(filteredGrps[0].replace(char[0], '').replace(char[1], ''))
                } else {
                    deciphered.push(filteredGrps[0].replace(char.replace('ch', '*')[0], '').replace(char.replace('ch', '*')[1], '').replace('*', 'ch'))
                }
            }

        })
        return deciphered.join('')
    },
};

export default {...methods,SEPARATOR}